export default __webpack_public_path__ + "static/media/D6.5194afe4.mp3";